module.exports = __webpack_public_path__ + "src/client/components/LandingPage/img/logo-forbes.png";


//////////////////
// WEBPACK FOOTER
// ./src/client/components/LandingPage/img/logo-forbes.png
// module id = 1216
// module chunks = 0